export interface IConfiguration {
  disableContextMenu?: boolean;
  disableMoveNodes?: boolean;
  showAddButton?: boolean;
  treeId?: string;
  dragZone?: string | null;
  dropZone?: string[] | null;
  isAnimation?: boolean;
}
